import React, { ChangeEvent } from "react";
import { QuestionInput } from "../../../../../__generated__/gql-types/globalTypes";
import { Col, Row } from "antd";
import { ErrorMessage, Field } from "formik";
import styles from "../../quizzForm.module.css";
import { UploadImageFile } from "../../../../UploadFile";
import { AnswersFillTheBlankComponent } from "./AnswersFillTheBlank";

interface FillTheBlankQuestionProps {
  index: number;
  question: QuestionInput;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    index?: number
  ) => void;
  loadingLoadImage: boolean;
  type: number;
  setLoadingLoadImage: React.Dispatch<React.SetStateAction<boolean>>;
  urlImageQuestion: string;
  setUrlImageQuestion: React.Dispatch<React.SetStateAction<string>>;
  handleImageQuestion: (newImage: string) => void;
}

export const FillTheBlankQuestion = ({
  index,
  question,
  loadingLoadImage,
  urlImageQuestion,
  type,
  handleChange,
  setLoadingLoadImage,
  setUrlImageQuestion,
  handleImageQuestion,
}: FillTheBlankQuestionProps) => {
  return (
    <Col
      key={`${index}_${new Date()}`}
      style={{
        backgroundColor: "#E6E7EF",
        borderRadius: 20,
        paddingRight: 30,
        paddingLeft: 30,
        paddingTop: 10,
      }}
    >
      <div style={{ marginBottom: 10, marginTop: 5 }}>
        <label htmlFor={`questions_${index}`}>
          {type === 4 ? `Pregunta ${index}` : `Ingrese la frase`}
        </label>
      </div>
      <Row>
        <Field
          id={`questions_${index}`}
          name="question"
          type="text"
          component="textarea"
          rows="10"
          className={styles.formFieldSelect}
          defaultValue={question?.question ?? ""}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            handleChange(event, index);
          }}
        ></Field>
        <ErrorMessage
          name="question"
          component="div"
          className={styles.error}
        />
      </Row>
      {type === 4 && (
        <Row>
          <UploadImageFile
            title={`Imagen de pregunta ${index}`}
            className={styles.uploadFile}
            questionTypeId={question.type_id}
            typeFile="questions"
            folder="questions"
            widthCover={300}
            heightCover={200}
            index={index}
            image={question.image ?? ""}
            urlImageQuestion={urlImageQuestion}
            loadingLoadImage={loadingLoadImage}
            setLoadingLoadImage={setLoadingLoadImage}
            handleImageQuestion={handleImageQuestion}
            setUrlImageQuestion={setUrlImageQuestion}
          />
        </Row>
      )}
      {type === 4 && (
        <AnswersFillTheBlankComponent
          handleChange={handleChange}
          question={question}
        />
      )}
    </Col>
  );
};
